import { PageProps } from "./types";

const Page: React.FC<PageProps> = ({ children }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      gap: "15px",
      alignItems: "center",
      justifyContent: "center",
      marginTop: "50px",
    }}
  >
    {children}
  </div>
);

export default Page;
